
/**
 * @description
 * 로드맵 상세 > 요약 > x개수업, 나이 등 정보
 */

import { mapGetters } from 'vuex';

import Icon from '@/components/common/icon/Icon.vue';

export default {
  name: 'CourseInfo',
  components: { Icon },
  computed: {
    ...mapGetters('course', ['classCount', 'minAge', 'maxAge']),
  },
};
